import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`	
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		line-height: 1;
		outline: none;
	}

    code {
        font-family: ${props => props.theme.monospaceFont};
        font-size: 14px;
    }

	ul, ol  {
		list-style-type: none;
	}

	html, body, #root {
		height: 100%;
	}

	html {
		font-size: 17px;
	}

	.link, a, a:hover, a:visited {
		color: ${props => props.theme.colors.white};
		text-decoration: underline;
		cursor: pointer;
    }
    
    p {
        margin: 1rem 0;
        line-height: 1.25;
    }

    h1, h2, h3, h4 {
        margin-bottom: 0.8rem;
    }

    h2 {
        font-size: 1.3rem;
    }
	h3 {
		font-size: 1.1rem;
	}	

	body {
		font-family: ${props => props.theme.font};
        color: ${props => props.theme.colors.white};
        background-color: ${props => props.theme.colors.black};
	}

	/* Form elements */
	input[type=text] {
		font-size: 1.1rem;
		padding: 0.2rem;
	}

`;

export default GlobalStyle;
